import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getCurrentSession } from "../../../lib/auth";

// /auth/callback/email — fallback magic-link landing page.
//
// Post-Supabase the canonical magic-link flow runs server-side: the email
// link points at the identity Worker's /v1/auth/email/callback (proxied via
// the Pages Function at /api/auth/email/callback), which verifies the
// token, mints a session JWT, sets the `__Host-session` cookie, and
// 302-redirects to /. The SPA usually never sees this route.
//
// We keep this component as a defensive fallback in case the server-side
// redirect chain ever lands a user here (e.g. an old email template that
// targets the SPA route directly). We check for a live session and bounce
// on to /, or surface an error if not.
export function EmailCallbackRoute() {
	const navigate = useNavigate();
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		void (async () => {
			try {
				const session = await getCurrentSession();
				if (!session) {
					throw new Error(
						"No session detected. Try opening the magic link again from your email.",
					);
				}
				void navigate("/", { replace: true });
			} catch (err) {
				setError(err instanceof Error ? err.message : "Sign-in failed");
			}
		})();
	}, [navigate]);

	return (
		<div className="flex min-h-screen items-center justify-center px-4">
			{error ? (
				<div className="max-w-md text-center text-sm text-[var(--color-danger)]">
					<p className="font-semibold">Email sign-in failed</p>
					<p className="mt-2 text-[var(--color-muted)]">{error}</p>
					<button
						onClick={() => navigate("/auth/login", { replace: true })}
						className="mt-4 rounded-md border border-[var(--color-border)] px-3 py-1.5 text-sm hover:border-[var(--color-accent)]"
					>
						Back to sign in
					</button>
				</div>
			) : (
				<p className="text-[var(--color-muted)]">Finishing sign-in…</p>
			)}
		</div>
	);
}
